<template lang="pug">
div.events--comments-list
  .events--comments-list-item(v-for="(comment, index) in comments")
    .events--comments-list-item-thumb
      span.events--comments-list-item-thumb-status(:class="comment.member_status_html_class") {{comment.member_status_text}}
      img.events--comments-list-item-thumb-path(:src="comment.member_publish_image_url" width="50" height="50")
    .events--comments-list-item-content
      .events--comments-list-item-content-user
        span.events--comments-list-item-content-user-name {{ totalCount - index }}. {{ comment.member_name }}
        var.events--comments-list-item-content-user-date （{{ comment.created_at_ago_in_words }}前）
        .events--comments-list-item-content-user-edit(v-if="comment.can_be_destroyed")
          .events--comments-list-item-content-user-edit-action.dropdown-toggle(data-toggle="dropdown") <i class="fa fa-angle-double-down font-awesome-icon" aria-hidden="true"></i>
          .events--comments-list-item-content-user-edit-dropdown.dropdown-menu.dropdown-menu-right
            p 投稿者または主催者はこのコメントを削除することができます。また、<span class="red bold">この操作は取り消せません。</span>本当に削除してよろしいですか？
            button.btn.btn-danger(@click="destoryComment(comment)") <i class="fa fa-trash" aria-hidden="true"></i> 削除する
      p.events--comments-list-item-content-text
        | {{ comment.body }}

  infinite-loading(spinner="waveDots" @infinite="infiniteHandler" :key="infiniteId")
    span(slot="no-results")
    span(slot="no-more")
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';

export default {
  components: { InfiniteLoading },
  props: {
    comments: {
      type: Array,
      default: () => ([])
    },
    totalCount: {
      type: Number,
      default: 0
    },
    infiniteId: {
      type: Number,
      default: 0
    }
  },
  methods: {
    infiniteHandler: function($state) {
      this.$emit('infinite-load', $state);
    },
    destoryComment: function(comment) {
      this.$emit('destory-comment', { comment_id: comment.id });
    }
  }
};
</script>
